module.exports = __webpack_public_path__ + "img/sample_offer.bc08e762.png";